module.exports = __webpack_public_path__ + "img/logo.267853fa.png";